// extracted by mini-css-extract-plugin
export default {"basketIcon":"BasketHeader_basketIcon__ed+Cb"};